import { render, staticRenderFns } from "./Norwegian.vue?vue&type=template&id=21e3418c&"
import script from "./Norwegian.vue?vue&type=script&lang=js&"
export * from "./Norwegian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports